var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPreviewIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun-seen-2997877",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.446,
    height: 18.203,
    viewBox: "0 0 28.446 18.203",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_20180",
    "data-name": "Path 20180",
    d: "M132.145,130.085l-1.107-1.107a16.752,16.752,0,0,0-23.67,0l-1.107,1.107a4.388,4.388,0,0,0,0,6.2l1.107,1.107a16.752,16.752,0,0,0,23.67,0l1.107-1.107a4.388,4.388,0,0,0,0-6.2Zm-1.443,4.764-1.1,1.1h0a14.72,14.72,0,0,1-20.8,0l-1.1-1.148a2.357,2.357,0,0,1,0-3.332l1.1-1.1a14.72,14.72,0,0,1,20.8,0l1.1,1.1a2.357,2.357,0,0,1,0,3.332Z",
    transform: "translate(-104.98 -124.082)",
    fill: "#333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_20181",
    "data-name": "Path 20181",
    d: "M267.579,192.5a5.079,5.079,0,1,0,3.591,1.488A5.079,5.079,0,0,0,267.579,192.5Zm0,8.127a3.047,3.047,0,1,1,2.155-.892A3.048,3.048,0,0,1,267.579,200.627Z",
    transform: "translate(-253.356 -188.528)",
    fill: "#333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewIcon);
export default __webpack_public_path__ + "static/media/preview_icon.2dbe2f7b3c48711254df0dd8794eb7c1.svg";
export { ForwardRef as ReactComponent };